<template>
    <div>
        <div class="container-md">
            <div class="row">
                <div class="col-lg-12">
                    <img src="./../../../assets/images/header-img.png" alt="" style="width:100%">
                    <div class="div-text">
                        <h1 class="text-uppercase ml-5 mt-2">Community name</h1>
                        <p class="ml-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-left: -5px; padding-right: 10px;">
                <div class="col-md-6 mt-3" >
                    <div class="card container-bg p-3 custom-scrollbar" style="height: 350px;">
                        <div class="flex-container mt-0">
                            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist" style="display: unset">
                                <a class="btn text-white btn-dark active item tab-styling "
                                   id="nav-next-event"
                                   data-toggle="tab" aria-controls="next-event" href="#next-event" role="tab"
                                   aria-selected="true">Next Event</a>
                                <a class="btn text-white btn-dark item tab-styling"
                                   data-toggle="tab"
                                   href="#upcomming-event" role="tab" aria-selected="false">Upcoming Events</a>
                                <a class="btn text-white btn-dark item tab-styling"
                                   data-toggle="tab"
                                   href="#calender-event" role="tab" aria-selected="false">Calendar</a>


                                <i class="fa fa-plus item" style="font-size: 24px;flex:unset;margin: 4px;cursor: pointer"
                                   data-toggle="modal" data-target="#Itemgroup"></i>

                            </div>
                        </div>
                        <div class="tab-content " id="nav-tabContent">
                            <div id="next-event" class="tab-pane fade show active" role="tabpanel"
                                 style="background-color: unset !important;">
                                <div class="flex-container flex-body p-2">
                                    <div class="item text-white pr-2" style="flex: 0;border-right: 1px solid;">
                                        <h4 style="margin: 0">14</h4>
                                        <p class="text-uppercase">May</p>
                                    </div>
                                    <div class="item text-white" style="flex: 18">
                                        <p style="margin: 0">Rehearsal from 18h to 20h</p>
                                    </div>
                                    <div class="item">
                                        <img src="./../../../assets/images/adult-1851571_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                    </div>
                                </div>
                                <div class="flex-container bg-white ml-4 mr-4 p-2">
                                    <div class="item  pr-2 pb-0" style="flex: 5">
                                        <b style="margin: 0">Song “Lorem ipsum”</b><br>
                                        <small>Lorem ipsum dolor set quorum sum</small>
                                    </div>
                                    <div class="item" style="margin-top: -16px">
                                        <img src="/assets/img/comment3.svg"
                                             alt=""><span class="ml-1">1</span>
                                        <img src="/assets/img/attach.svg" class="ml-3"
                                             alt=""><span class="ml-1">2</span>
                                        <span class="panel-heading collapsed ml-3" data-toggle="collapse" data-target="#demo" style="cursor: pointer"> <i class="chevron fa " ></i></span>
                                        <!--                                    <span data-toggle="collapse" data-target="#demo" class="accordion-toggle fa fa-caret-right ml-3"></span>-->
                                    </div>
                                    <div id="demo" class="collapse">


                                        <div class="flex-container bg-white  mt-0">
                                            <div class="item">
                                                <div class="arrow_box">
                                                    <p style="color: #4192D9; font-size: 14px; padding: 12px;">Sed ut
                                                        perspiciatis unde omnis iste natus error sit voluptatem accusantium
                                                        doloremque</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <img src="/assets/img/attach_blue.svg" alt=""
                                                     style="padding-left: 10px;">
                                            </div>
                                            <div class="col-5">
                                                <p style="color: #4192D9; font-size: 13px;">image.png</p>

                                            </div>
                                            <div class="col-2">
                                                <i class="fa fa-trash" aria-hidden="true" style="color: #4192D9;"></i>

                                            </div>
                                        </div>
                                    </div>

                                </div>





                            </div>
                            <!-- upcoming events start-->
                            <div id="upcomming-event" class="tab-pane fade " role="tabpanel"
                                 style="background-color: unset !important;">
                                <div class="flex-container flex-body p-2">
                                    <div class="item text-white pr-2" style="flex: 0;border-right: 1px solid;">
                                        <h4 style="margin: 0">14</h4>
                                        <p class="text-uppercase">May</p>
                                    </div>
                                    <div class="item text-white" style="flex: 18">
                                        <p style="margin: 0">Optreden tijdens vlaggetjesdag Almere Buiten</p>
                                    </div>
                                    <div class="item">
                                        <img src="./../../../assets/images/adult-1851571_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                    </div>
                                </div>
                                <div class="flex-container flex-body p-2">
                                    <div class="item text-white pr-2" style="flex: 0;border-right: 1px solid;">
                                        <h4 style="margin: 0">20</h4>
                                        <p class="text-uppercase">May</p>
                                    </div>
                                    <div class="item text-white" style="flex: 18">
                                        <p style="margin: 0">Optreden tijdens vlaggetjesdag Almere Buiten</p>
                                    </div>
                                    <div class="item">
                                        <img src="./../../../assets/images/adult-1851571_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                    </div>
                                </div>
                                <div class="flex-container flex-body p-2">
                                    <div class="item text-white pr-2" style="flex: 0;border-right: 1px solid;">
                                        <h4 style="margin: 0">30</h4>
                                        <p class="text-uppercase">May</p>
                                    </div>
                                    <div class="item text-white" style="flex: 18">
                                        <p style="margin: 0">Optreden tijdens vlaggetjesdag Almere Buiten</p>
                                    </div>
                                    <div class="item">
                                        <img src="./../../../assets/images/adult-1851571_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                        <img src="./../../../assets/images/guitar-869217_1920.png"
                                             style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                             alt="">
                                    </div>
                                </div>
                            </div>

                            <!-- upcoming events end -->
                            <!-- calender start-->
                            <div id="calender-event" class="tab-pane fade mt-2" role="tabpanel"
                                 style="background-color: unset !important;">
                                <Calendar/>
                            </div>
                            <!-- calender end -->


                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-3">
                    <div class="card container-bg p-3 custom-scrollbar" style="height: 350px;">
                        <h3 class="text-center mb-3 text-uppercase">News</h3>
                        <div class="flex-container flex-body p-2">
                            <div class="item text-white" style="flex: 18 1 0%">
                                <p style="margin: 0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do…</p>
                                <small class="float-right">6 hours ago</small>
                            </div>
                            <div class="item">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/guitar-869217_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/guitar-869217_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row" style="margin-left: -5px; padding-right: 10px;">
                <div class="col-md-6 mt-3">
                    <div class="card container-bg p-3 custom-scrollbar" style="height: 350px;">
                        <h3 class="text-center text-uppercase">Committees<i class="fa fa-plus ml-3 " data-toggle="modal"
                                                                                      data-target="#newItemgroup" style="font-size: 24px;cursor: pointer"></i></h3>
                        <div class="flex-container flex-body p-2">
                            <div class="item" style="flex: 0">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 50px;width: 50px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                            <div class="item text-white">
                                <p style="margin: 0">Muzikanten</p>
                            </div>
                            <div class="item">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                            <div class="item text-white text-center">
                                <img src="/assets/img/bell(1).svg"
                                     alt="" class="m-1" style="height: 20px">
                                <img src="/assets/img/doc.svg"
                                     alt="" class="m-1" style="height: 20px">
                                <img src="/assets/img/Conversation.svg"
                                     alt="" class="m-1" style="height: 20px">
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-6 mt-3">
                    <div class="card container-bg p-3 custom-scrollbar" style="height: 350px;">
                        <h3 class="text-center text-uppercase">itemgroups <i class="fa fa-plus ml-3 " data-toggle="modal"
                                                                             data-target="#itemgroupsModal" style="font-size: 24px;cursor: pointer"></i></h3>
                        <div class="flex-container flex-body p-2">
                            <div class="item" style="flex: 0">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 50px;width: 50px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                            <div class="item text-white">
                                <p style="margin: 0">Music</p>
                            </div>
                            <div class="item">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                            <div class="item text-white text-center">
                                <img src="/assets/img/bell(1).svg"
                                     alt="" class="m-1" style="height: 20px">
                                <img src="/assets/img/doc.svg"
                                     alt="" class="m-1" style="height: 20px">
                                <img src="/assets/img/Conversation.svg"
                                     alt="" class="m-1" style="height: 20px">
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <!--        itemgroups modal start-->
            <div class="modal fade" id="itemgroupsModal" tabindex="-1" role="dialog"
                 aria-labelledby="exampleModalCenterTitle"
                 aria-hidden="true">
                <div class="modal-dialog " role="document">
                    <div class="modal-content">
                        <div class="modal-header" style="border-bottom: unset">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">

                                <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <h5 class="text-uppercase">Create a new itemgroup</h5>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <img src="/assets/img/blank-profile-picture-973460_640.png"
                                                     style="height: 100px;width: 100px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                                     alt="">
                                                <button class="btn-dark ml-3">Upload</button>
                                            </div>

                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="name">Name</label>
                                                <input type="text" class="form-control" id="">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="textarea">Include items :</label>
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <img src="/assets/img/attach_blue.svg"
                                                             alt="">
                                                    </div>
                                                    <div class="col-lg-7">
                                                        <label style="color: #4192D9">Main Song: Dolor setsum lorem</label>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <i class="fa fa-trash" style="color: #4192D9; margin-left:110px;"
                                                           aria-hidden="true"></i>
                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <img src="/assets/img/attach_blue.svg"
                                                             alt="">
                                                    </div>
                                                    <div class="col-lg-7">
                                                        <label style="color: #4192D9">Second Song: Lorem ipsum</label>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <i class="fa fa-trash" style="color: #4192D9; margin-left:110px;"
                                                           aria-hidden="true"></i>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                        <div class="col-md-10">
                                            <div class="form-group">

                                                <input type="text" class="form-control" id="name" value="Text input name">
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="btn btn-dark"><img src="/assets/img/attach_blue.svg"
                                                                              alt=""></button>
                                        </div>

                                        <i class="fa fa-plus float-left "
                                           style="font-size: 24px;cursor: pointer; margin-left: 14px; margin-top: 8px;"></i>


                                    </div>
                                </div>
                                <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                                    <div class="row">

                                        <div class="col-md-12 col-12 mb-3 p-0">
                                            Select related committee:
                                        </div>
                                        <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                                            <div class="row">
                                                <div class="col-md-10 custom-scrollbar" style="height: 200px;">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Amy member name
                                                        </label>
                                                    </div>
                                                    <div class="form-check pt-3 ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Borem ipsum
                                                        </label>
                                                    </div>
                                                    <div class="form-check pt-3 ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Colorumset Qutern
                                                        </label>
                                                    </div>
                                                    <div class="form-check pt-3 ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Dember name
                                                        </label>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>


                                        <div class="col-md-12 col-12 mb-3 p-0">
                                            If proceeds, select an existing itemgroup to contain this itemgroup:
                                        </div>
                                        <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                                            <div class="row">
                                                <div class="col-md-10 custom-scrollbar" style="height: 200px;">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Music
                                                        </label>
                                                        <span class="panel-heading collapsed ml-5" data-toggle="collapse"
                                                              data-target="#dropdown-list" style="cursor: pointer;"> <i
                                                                class="chevron fa " style=" margin-left: 90px"></i></span>
                                                        <div id="dropdown-list" class="collapse">


                                                            <div class="flex-container mt-0">
                                                                <div class="item">
                                                                    <div class=" ml-2">
                                                                        <input class="form-check-input" type="checkbox"
                                                                               value=""
                                                                               id="defaultCheck1">
                                                                        <label class="form-check-label" for="defaultCheck1">
                                                                            Music
                                                                        </label>
                                                                    </div>
                                                                    <div class=" ml-2">
                                                                        <input class="form-check-input" type="checkbox"
                                                                               value=""
                                                                               id="defaultCheck1">
                                                                        <label class="form-check-label" for="defaultCheck1">
                                                                            Genre
                                                                        </label>
                                                                    </div>
                                                                    <div class=" ml-2">
                                                                        <input class="form-check-input" type="checkbox"
                                                                               value=""
                                                                               id="defaultCheck1">
                                                                        <label class="form-check-label" for="defaultCheck1">
                                                                            Rithm
                                                                        </label>
                                                                    </div>
                                                                    <div class=" ml-2">
                                                                        <input class="form-check-input" type="checkbox"
                                                                               value=""
                                                                               id="defaultCheck1">
                                                                        <label class="form-check-label" for="defaultCheck1">
                                                                            Mood
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>


                                                    <div class="form-check pt-3 ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Default checkbox
                                                        </label>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                </div>


                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <button class="btn-dark float-right mt-3">Done</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>


<createCommunity></createCommunity>
        <committeeModal :isEdit="false"></committeeModal>
    </div>
</template>

<script>
    import createCommunity from "./createCommunity";
    import committeeModal from "../../committees/pages/committeeModal";
    export default {
        name: "documents",
        components:{
            createCommunity,committeeModal
        }
    }
</script>

<style scoped>
    /*.container{*/
    /*    position: relative;*/
    /*}*/
    .div-text{
        position: absolute;
        background: #292929 0% 0% no-repeat padding-box;
        opacity: 0.8;
        color: white;
        height: 175px;
        top: 20%;
        left: 30px;
        width: 50%;
        margin-left: -4px;

    }
    .card {
        border: unset;
        border-radius: unset;
    }

    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;
        margin-top: 10px;
        opacity: 1;
    }

    .flex-body {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .item {
        flex: 1 1 18%;
        height: auto;
        margin: 4px;
        margin-right: 10px;
        padding: 10px 0;
        width: auto;
    }

    .custom-scrollbar {
        overflow-y: scroll;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        background: #F4F5F7 0% 0% no-repeat padding-box;
        border-radius: 5px;
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 3px;
        background-color: #F5F5F5;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #4192D9 0% 0% no-repeat padding-box;
        border-radius: 5px;
    }

    .tab-styling {
        padding: 5px !important;
        font-size: 16px !important;
    }

    .active {
        background-color: #4192D9 !important;
        border: #4192D9;
    }

    .vc-container {
        width: 100%;
    }

    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px;
            margin: 1.75rem auto;
            margin-top: 9rem;
        }

        .delete-modal {
            max-width: 600px !important;
            margin: 1.75rem auto;
        }
    }

    .form-control, .input-group-text {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 4px;
        opacity: 1;
        border: 1px #ced4da;;
    }

    .arrow_box {
        position: relative;
        background: white;
        border: 1px solid #4192D9;
        border-radius: 4px;
    }

    .arrow_box:after, .arrow_box:before {
        bottom: 100%;
        left: 25%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .arrow_box:after {
        border-color: rgba(136, 183, 213, 0);
        border-bottom-color: white;
        border-width: 14px;
        margin-left: -57px;
    }

    .arrow_box:before {
        border-color: rgba(194, 225, 245, 0);
        border-bottom-color: #4192D9;
        border-width: 15px;
        margin-left: -58px;
    }
    .panel-heading .chevron:after {
        content: "\f0d7";
    }
    .panel-heading.collapsed .chevron:after {
        content: "\f0da";
    }
</style>
